import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import InquiryForm from "@/components/InquiryForm";

export default function QuoteDialog({ open, onOpenChange, defaultProduct }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        data-testid="quote-dialog"
        className="max-h-[90vh] overflow-y-auto rounded-3xl border-[var(--border)] bg-[var(--bg)] sm:max-w-lg"
      >
        <DialogHeader>
          <DialogTitle className="font-display text-3xl tracking-tight text-[var(--ink)]">
            Request Wholesale Price
          </DialogTitle>
          <DialogDescription className="text-[var(--ink-soft)]">
            {defaultProduct
              ? `Enquiring about ${defaultProduct}. Share your details and we'll send competitive bulk pricing.`
              : "Share your requirement and we'll send competitive bulk pricing."}
          </DialogDescription>
        </DialogHeader>
        <InquiryForm defaultProduct={defaultProduct} compact onSuccess={() => onOpenChange(false)} />
      </DialogContent>
    </Dialog>
  );
}
